import {Injectable} from '@angular/core';
import {OrganizationGameCategoryData} from "../interfaces/organization-game-category-data";
import {GameCategoryData} from "../interfaces/game-category-data";
import {DataService} from "./data.service";
import {Store} from "@ngrx/store";
import {AppState} from "../store";
import {getActiveClassId} from "../store/selectors/teacher.selector";
import {take} from "rxjs";
import {GameCategoryResponse} from "../interfaces/game-category-response";
import {EGame} from "../enums/game";
import {GameCategory} from "../interfaces/backend/game-category";

@Injectable({
  providedIn: 'root'
})
export class GameCategoryService {
  private gameCategoriesStaticData: GameCategoryData[] = [
    {id: 1, title: "In der Natur", iconPath: "/assets/img/game-categories/Category=Berufsfelder-Natur.svg"},
    {id: 2, title: "Mit Genuss", iconPath: "/assets/img/game-categories/Category=Berufsfelder-Lebensmittel.svg"},
    {id: 3, title: "Mit Kreativität", iconPath: "/assets/img/game-categories/Category=Berufsfelder-Kreativitaet.svg"},
    {id: 4, title: "Am Bau", iconPath: "/assets/img/game-categories/Category=Berufsfelder-Bau.svg"},
    {id: 5, title: "Unter Strom", iconPath: "/assets/img/game-categories/Category=Berufsfelder-Unter-Strom.svg"},
    {id: 6, title: "IT & Forschung", iconPath: "/assets/img/game-categories/Category=Berufsfelder-IT-Forschung.svg"},
    {id: 7, title: "Im Büro & Handel", iconPath: "/assets/img/game-categories/Category=Berufsfelder-Buero-Verwaltung.svg"},
    {id: 8, title: "In Medien & Kultur", iconPath: "/assets/img/game-categories/Category=Berufsfelder-Medien-Kultur.svg"},
    {id: 9, title: "Mit Menschen", iconPath: "/assets/img/game-categories/Category=Berufsfelder-Menschen.svg"},
    {id: 10, title: "Grüne Arbeitswelt", iconPath: "/assets/img/game-categories/Category=Gruene Arbeitswelt.svg"},
    {id: 11, title: "Lokale Anbieter", iconPath: "/assets/img/game-categories/Category=Kunterbunt.svg"},
    {id: 12, title: "Bewerbungswelt", iconPath: "/assets/img/game-categories/Category=Bewerbungswelt.svg"},
    {id: 13, title: "Kunterbunt", iconPath: "/assets/img/game-categories/Category=Kunterbunt.svg"},
    {id: 14, title: "Weiterführende Schule", iconPath: "/assets/img/game-categories/Category=Weiterfuehrende Schulen.svg"},
    {id: 15, title: "Anbieter", iconPath: "/assets/img/game-categories/Category=Kunterbunt.svg"},
  ];
  constructor(private data: DataService, private store: Store<AppState>) {
  }
  // loadGameCategories(): Promise<GameCategoryData[]> {
  //   return new Promise<GameCategoryData[]>((resolve, reject) => {
  //     this.data.getGameCategoriesTeacher()
  //
  //     this.gameCategories = dummyResponse;
  //
  //     resolve(dummyResponse);
  //   });
  // }

  updateRemoteGameCategories(activeCategoryIds: number[]): void {
    this.store.select(getActiveClassId()).pipe(take(1)).subscribe((classId) => {
      this.data.setGameCategoriesTeacher(classId, activeCategoryIds).pipe(take(1)).subscribe((response) => {
        // console.log(response);
      });
    })
  }

  loadOrganizationGameCategoryData(): Promise<OrganizationGameCategoryData> {
    return new Promise(async (resolve, reject) => {

      let categories = this.gameCategoriesStaticData;

      this.store.select(getActiveClassId()).pipe(take(1)).subscribe((classId) => {
        this.data.getGameCategoriesTeacher(classId).pipe(take(1)).subscribe((allGameCategoriesTeacher) => {

          // console.log("allGameCategoriesTeacher", allGameCategoriesTeacher);
          let gameCategoriesTeacher = (allGameCategoriesTeacher || []).filter((el) => el.id != "15");

          const serverCategoriesState: GameCategoryResponse[] = gameCategoriesTeacher.map((category) => this.mapGameCategoryResponseObject(category));
          this.updateLocalCategoryStaticData(serverCategoriesState);
          const gameCategoriesFromServer: GameCategoryResponse[] = gameCategoriesTeacher.map((el) => this.mapGameCategoryResponseObject(el));
          const response = this.mergeCategoryProgress(categories, gameCategoriesFromServer);
          resolve(response);
        });
      });




    })
  }

  loadStudentGameCategoryData(clientId: string, gameId: EGame): Promise<OrganizationGameCategoryData> {
    return new Promise<OrganizationGameCategoryData>((resolve, reject) => {
      this.data.getGameCategoriesStudent(clientId, gameId).pipe(take(1)).subscribe((gameCategoriesStudent) => {
        const serverCategoriesState: GameCategoryResponse[] = (gameCategoriesStudent || []).map((category) => this.mapGameCategoryResponseObject(category));
        this.updateLocalCategoryStaticData(serverCategoriesState);

        let finalResponse: OrganizationGameCategoryData = {
          items: []
        }

        finalResponse.items = serverCategoriesState
          .filter((serverCategory) => serverCategory.isSelected && serverCategory.isActive)
          .map((serverCategory) => {
            const progress: {gameId: EGame, points: number, round: number}[] = [];

            serverCategory.progress.forEach((el) => {
              progress.push({gameId: el.gameType as EGame, points: el.highscore, round: el.roundNumber});
            });

            // console.log("serverCategory", serverCategory);

            return {
              categoryData: this.getGameCategoryDataById(serverCategory.id),
              progress: progress,
              isActive: serverCategory.isActive,
              isSelected: serverCategory.isSelected,
              multiplier: serverCategory.multiplier,
              scoreType: serverCategory.scoreType ?? 0,
              completedPoints: serverCategory.completedPoints ?? 0,
              totalPoints: serverCategory.totalPoints ?? 0,
              completedTasks: serverCategory.completedTasks ?? 0,
              totalTasks: serverCategory.totalTasks,
              isQuestOfMonth: serverCategory.isQuestOfMonth ?? false
            }
          });

        resolve(finalResponse);

      })
    });
  }

  private mergeCategoryProgress(gameCategoryData: GameCategoryData[], organizationCategoryProgressData: GameCategoryResponse[]): OrganizationGameCategoryData {
    const data: OrganizationGameCategoryData = {items: []};
    const gameCategoryDataIds = organizationCategoryProgressData.map((el) => el.id);

    gameCategoryData = gameCategoryData.filter((el) => {
      return gameCategoryDataIds.indexOf(el.id) !== -1;
    });

    data.items = gameCategoryData.map((el) => {
      let foundProgressData = organizationCategoryProgressData.find((gameCategoryDataItem) => {
        return gameCategoryDataItem.id === el.id;
      })

      if(!foundProgressData) {
        throw new Error(`Category Progress Data for ${el.title} was not found!`);
      }

      const progress: {gameId: EGame, points: number, round: number}[] = [];
      foundProgressData.progress.forEach((el) => {
        progress.push({gameId: el.gameType as EGame, points: el.highscore, round: el.roundNumber});
      });


      return {
        categoryData: el,
        progress: progress,
        isActive: true,
        isSelected: true,
        multiplier: 1,
        scoreType: foundProgressData.scoreType,
        completedPoints: foundProgressData.completedPoints,
        totalPoints: foundProgressData.totalPoints,
        completedTasks: foundProgressData.completedTasks,
        totalTasks: foundProgressData.totalTasks,
        isQuestOfMonth: foundProgressData.isQuestOfMonth
      }
    })

    return data;
  }

  private mapGameCategoryResponseObject(obj: GameCategory): GameCategoryResponse {
    return {
      id: parseInt(obj.id),
      name: obj.name,
      isActive: obj.isActive,
      isSelected: obj.isSelected,
      progress: (obj.progress ?? []).map((el) => ({
        id: parseInt(el.id),
        gameType: el.gameType,
        roundNumber: el.roundNumber,
        highscore: el.highscore
      })),
      // not queried for teachers, mergeCategoryProgress sets a fixed multiplier there
      multiplier: obj.multiplier ?? 1,
      scoreType: obj.scoreType ?? 0,
      completedPoints: obj.completePoints ?? 0,
      totalPoints: obj.totalPoints ?? 0,
      completedTasks: obj.completeEntries ?? 0,
      totalTasks: obj.totalEntries ?? 0,
      isQuestOfMonth: obj.isQuestOfMonth ?? false
    }
  }

  private updateLocalCategoryStaticData(serverCategories: GameCategoryResponse[]) {
    serverCategories.forEach((serverCategory) => {
      if(serverCategory.id === 11 || serverCategory.id === 15) return; // these two categories exists, but we dont use them ("Anbieter", "Local Anbieter")
      const foundLocalCategoryIdx = this.gameCategoriesStaticData.findIndex((el) => el.id === serverCategory.id);
      if(foundLocalCategoryIdx === -1) {
        this.gameCategoriesStaticData.push({id: serverCategory.id, title: serverCategory.name, iconPath: this.gameCategoriesStaticData[0].iconPath});
      } else {
        this.gameCategoriesStaticData[foundLocalCategoryIdx] = {
          ...this.gameCategoriesStaticData[foundLocalCategoryIdx],
          title: serverCategory.name
        }
      }
    })
  }

  private generateDummyProgressArray(): {gameId: EGame, points: number}[] {
    return [{gameId: EGame.QUIZ, points: Math.floor(Math.random() * 1200)}, {gameId: EGame.CLICK_THE_PIC, points: Math.floor(Math.random() * 1200)}, {gameId: EGame.NOTSET, points: Math.floor(Math.random() * 1200)}];
  }

  public getGameCategoryDataById(id: number): GameCategoryData {
    const targetIdx = this.gameCategoriesStaticData.findIndex((el) => el.id === id);
    return this.gameCategoriesStaticData[targetIdx];
  }


}
